export default {
  LANGUAGES: ["it", "en"],
};
